<template>
  <modal :visible="visible" @on-close="onClose()">
    <template v-slot:header>
      <h6 class="userName">{{ product.sku }} - {{ product.name }}</h6>
    </template>

    <template v-slot:body>
      <div style="background-color:--main-bg-color;" class="nav-pills nav-fill">
        <div class="head-info">
          <th>
            <h6 class="userName">{{ product.sku }} - {{ product.name }}</h6>
            <p>
              {{ parseFloat(product.codeOfUnit) }} - {{ product.nameOfUnit }} -
              ({{ product.unitOfSell }})
            </p>
            <p>
              {{ $t("products.weight") }} - {{ parseFloat(product.url) }}
              {{ "kg" }}
            </p>
          </th>
        </div>
      </div>

      <!-- IMAGE -->
      <div class="product-image-wrap" v-if="imageToShow">
        <div class="product-image-square">
          <img
            class="product-image"
            :src="imageToShow"
            :alt="`${product.sku} - ${product.name}`"
            loading="lazy"
            @error="onImgError"
          />
        </div>
      </div>

      <div class="product-usertext">
        {{ product.userText }}
      </div>
    </template>

    <template v-slot:footer>
      <button class="btn" @click="onClose()">
        {{ $t("buttons.close") }}
      </button>
    </template>
  </modal>
</template>

<script>
import { currencyMixin } from "../mixins";
import Modal from "./Modal";

export default {
  name: "ProductInfoModal",
  components: { Modal },
  mixins: [currencyMixin],
  props: {
    product: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    visible: Boolean,
  },
  data() {
    return {
      imgFailed: false,
    };
  },
  computed: {
    imageToShow() {
      if (this.imgFailed) return null;
      return this.product?.imageUrl || null;
    },
  },
  watch: {
    "product.imageUrl"() {
      this.imgFailed = false;
    },
    visible(v) {
      if (v) this.imgFailed = false;
    },
  },
  methods: {
    onClose() {
      this.$emit("on-close");
    },
    onImgError() {
      this.imgFailed = true;
    },
  },
};
</script>

<style scoped>
.product-image-wrap {
  margin: 12px 0 8px;
  display: flex;
  justify-content: center;
}

/* kwadrat z lekką ramką */
.product-image-square {
  width: 220px;
  height: 220px;
  border-radius: 12px;
  overflow: hidden;
  border: 1px solid rgba(0, 0, 0, 0.12);
  background: rgba(0, 0, 0, 0.03);
  display: flex;
  align-items: center;
  justify-content: center;
}

/* obrazek w środku: ładnie wypełnia, bez zniekształceń */
.product-image {
  width: 100%;
  height: 100%;
  object-fit: contain; /* jak chcesz „kadr” to zmień na cover */
}

.product-usertext {
  margin-top: 8px;
}
</style>
